import apiClient from '../utils/apiClient';

const login = async ({ email, password }) => {
  try {
    const response = await apiClient.post('/api/auth/login', { email, password });
    return { success: true, token: response.data.token };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || 'Login failed',
      code: error.response?.data?.code || null
    };
  }
};

const register = async ({ name, email, password, companyName, isOwner }) => {
  try {
    await apiClient.post('/api/auth/register', { name, email, password, companyName, isOwner });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.response?.data?.error || 'Registration failed' };
  }
};

const resendVerification = async (email) => {
  try {
    const response = await apiClient.post('/api/auth/resend-verification', { email });
    return {
      success: true,
      message: response.data.message
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to resend email',
      code: error.response?.data?.code || null
    };
  }
};

export const verifyEmail = async (token) => {
  const response = await apiClient.get(`/api/auth/verify?token=${token}`);
  return response.data;
};

const authService = { login, register, resendVerification };
export default authService;
